import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";

import FormPage from "ui/FormPage";
import { PrimaryButton, OutlineButton } from "ui/Buttons";
import FormTextField from "ui/FormTextField";

import { getReconocimientoById, updateReconocimiento } from "../services/reconocimientos";

export default function EditarReconocimiento() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [createdAt, setCreatedAt] = useState("");

  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [errors, setErrors]   = useState([]);

  useEffect(() => {
    let cancel = false;
    (async () => {
      setLoading(true); setErrors([]);
      try {
        const r = await getReconocimientoById(id);
        if (cancel) return;
        setName(r?.name ?? r?.nombre ?? "");
        setType(r?.type ?? r?.tipo ?? "");
        setCreatedAt(r?.created_at ?? r?.createdAt ?? "");
      } catch (e) {
        if (!cancel) setErrors([e?.response?.data?.message || e.message || String(e)]);
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => { cancel = true; };
  }, [id]);

  const isValid = useMemo(() => !!name.trim(), [name]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) return;
    setSaving(true); setErrors([]);
    try {
      const payload = { name: name.trim(), ...(type ? { type: type.trim() } : {}) };
      await updateReconocimiento(id, payload);
      navigate("/catalogos/reconocimientos", { replace: true });
    } catch (e) {
      setErrors([e?.response?.data?.message || e.message || String(e)]);
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormPage
      title="Editar reconocimiento"
      onBack={() => navigate("/catalogos/reconocimientos")}
      pageMaxWidth={1100}
      contentMaxWidth={900}
      actions={
        <>
          <PrimaryButton type="submit" form="form-rec" disabled={!isValid || saving || loading}>
            {saving ? "Guardando..." : "Guardar"}
          </PrimaryButton>
          <OutlineButton onClick={() => navigate("/catalogos/reconocimientos")}>
            Cancelar
          </OutlineButton>
        </>
      }
    >
      {errors.length > 0 && <Alert severity="error" sx={{ mb: 2 }}>{errors.join(", ")}</Alert>}

      <form id="form-rec" onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <FormTextField label="Nombre*" value={name} onChange={(e) => setName(e.target.value)} required />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormTextField label="Tipo (opcional)" value={type} onChange={(e) => setType(e.target.value)} />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormTextField label="Creado" value={createdAt} disabled />
          </Grid>
        </Grid>
      </form>
    </FormPage>
  );
}
